import { getRecipe } from 'selectors/menu-recipes/getRecipe'

export const getMenuRecipeUuidForDetails = ({ menuRecipeDetails }) =>
  menuRecipeDetails.get('recipeUuid', null)

export const getMenuRecipeDetailOpenFlexPortionEditor = ({ menuRecipeDetails }) =>
  menuRecipeDetails.get('openFlexPortionEditor', false)

export const getMenuRecipeForDetails = ({ recipesV3, menuRecipeDetails }) => {
  const recipeUuid = getMenuRecipeUuidForDetails({ menuRecipeDetails })

  if (!recipeUuid) {
    return null
  }

  return getRecipe(recipeUuid)({ recipesV3 })
}
